// Custom fabric events fired to mark the beginning and end of grouped modifications
// onChange handler will not be called while in a group.
// Groups may be nested and the onChange handler will not be called
// until the last group is ended.
export const FABRIC_GROUP_START = 'groupedEvents:start';
export const FABRIC_GROUP_END = 'groupedEvents:end';
